"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleWrapper = exports.RowWrapper = void 0;
const styles_1 = require("@mui/material/styles");
exports.RowWrapper = (0, styles_1.styled)("div")({
    width: "100%",
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    marginBottom: "40px"
});
exports.TitleWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    marginBottom: "16px",
    justifyContent: "center",
    alignItems: "center",
    "> button": {
        marginLeft: "24px"
    }
});
